import { render } from "./AddGroupImage.vue?vue&type=template&id=41252518&scoped=true&ts=true"
import script from "./AddGroupImage.vue?vue&type=script&lang=ts"
export * from "./AddGroupImage.vue?vue&type=script&lang=ts"

import "./AddGroupImage.vue?vue&type=style&index=0&id=41252518&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41252518"]])

export default __exports__